import styled from 'styled-components';

import { mediaBreakpointMixin, token } from '@zillow/constellation';
import HomeSparkleBgLarge from '../../../images/home-sparkle-bg-large.png';
import HomeSparkleBgSmall from '../../../images/home-sparkle-bg-small.png';

export const StyledDiv = styled.div`
  /* color not in constellation */
  background-color: #f0faff;
  background-image: url(${HomeSparkleBgSmall});
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: 100%;
  border-radius: ${token('radii.md')}px;
  box-shadow: ${token('shadows.shadow400')};
  padding: ${token('spacing.lg')}px;
  min-height: 100%;
  @media ${mediaBreakpointMixin('lg')} {
    background-image: url(${HomeSparkleBgLarge});
  }
`;

export const StyledContainer = styled.div`
  @media ${mediaBreakpointMixin('md')} {
    min-height: 600px;
    padding: 0 ${token('spacing.lg')}px;
  }
  @media ${mediaBreakpointMixin('xl')} {
    min-height: 650px;
  }
`;
